import { render, staticRenderFns } from "./sallRules.vue?vue&type=template&id=5d37f53c&scoped=true"
import script from "./sallRules.vue?vue&type=script&lang=js"
export * from "./sallRules.vue?vue&type=script&lang=js"
import style0 from "./sallRules.vue?vue&type=style&index=0&id=5d37f53c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37f53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d37f53c')) {
      api.createRecord('5d37f53c', component.options)
    } else {
      api.reload('5d37f53c', component.options)
    }
    module.hot.accept("./sallRules.vue?vue&type=template&id=5d37f53c&scoped=true", function () {
      api.rerender('5d37f53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sall/sallRules.vue"
export default component.exports